
import { Component, Input, OnChanges, OnDestroy } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { WebService, lastValueFrom } from '@services';
import { MatIconModule } from '@angular/material/icon'
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner'

@Component({
  selector: 'rms-file-preview',
  standalone: true,
  imports: [MatIconModule, MatProgressSpinnerModule],
  templateUrl: './rms-file-preview.component.html',
  styleUrls: ['./rms-file-preview.component.scss']
})
export class RmsFilePreviewComponent implements OnChanges, OnDestroy {

  @Input() path!: string;     // blob path: "viewer/tally/file.xlsx"
  @Input() filename?: string; // optional display name
  loading = false;
  error?: string;

  sasUrl?: string;
  safeUrl?: SafeResourceUrl;
  mime?: string;

  constructor(private web: WebService, private sanitizer: DomSanitizer) { }

  ngOnChanges(): void {
    console.log(this.path)
    if (this.path) this.load();

  }

  ngOnDestroy(): void {
    if (this.sasUrl?.startsWith('blob:')) URL.revokeObjectURL(this.sasUrl);
  }

  private async load() {
    
    try {
      this.loading = true;
      this.error = undefined;

      const resp: any = await lastValueFrom(
        this.web.getWebCall('files', 'signed-url', {
          params: [{ name: 'path', value: this.path }]
        })
      );
      console.log(resp);
      this.mime = resp?.contentType ?? 'application/octet-stream';
      this.sasUrl = resp?.url ?? null;

      if (!this.sasUrl) {
        this.error = 'Preview URL unavailable';
        this.loading = false;
        return;
      }

      // Office docs → wrap in Office viewer
      if (this.isOfficeMime(this.mime!)) {
        this.safeUrl =
          this.sanitizer.bypassSecurityTrustResourceUrl(
            `https://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(this.sasUrl)}`
          );
      }

      // PDFs use direct SAS
      else if (this.mime === 'application/pdf') {
        this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.sasUrl);
      }

      // Images → normal <img>
      else if (this.mime!.startsWith('image/')) {
        this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.sasUrl);
      }

      // Text → fetch text directly
      else if (this.mime!.startsWith('text/') || this.mime === 'application/json') {
        const blob = await lastValueFrom(
          this.web.getWebCall('files', 'download', {
            params: [{ name: 'path', value: this.path }],
            responseType: 'text'
          })
        );
        this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl('');
        this.error = blob; // text displayed separately
      }

      // Default → fallback
      else {
        this.safeUrl = undefined;
      }

    } catch (err: any) {
      console.error('Preview failed:', err);
      this.error = err?.message ?? 'Failed loading preview';
    } finally {
      this.loading = false;
    }
  }


  // MIME helpers
  isOfficeMime(mime: string): boolean {
    return mime.startsWith('application/vnd.openxmlformats') ||
      mime === 'application/msword' ||
      mime === 'application/vnd.ms-excel' ||
      mime === 'application/vnd.ms-powerpoint';
  }

}
